import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { green, red, grey } from '@mui/material/colors';
import { StatusIconType } from './enums';

const statusMap: Record<
  StatusIconType,
  { color: string; icon: React.ElementType }
> = {
  [StatusIconType.Success]: {
    icon: CheckCircleIcon,
    color: green[600],
  },
  [StatusIconType.Error]: {
    icon: ErrorIcon,
    color: red[400],
  },
  [StatusIconType.Pending]: {
    icon: RemoveCircleIcon,
    color: grey[400],
  },
};

export const getStatusIcon = (type: StatusIconType) => statusMap[type];
